var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.validUrl},on:{"error":_vm.setImageUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }